<app-card [hidHeader]="true" [contentType]="'experiences'">
    <div class="row">
        <div class="col-12 col-md-3" *ngFor="let exp of (experiences$ | async)?.data">
            <div class="card mb-3">
                <div class="image-wrapper" [id]="'exp-' + exp.id" [style.backgroundImage]="'url(' + environment.imageCDN + environment.imageFolder + '/' + exp.image +')'">
                    <!-- <div class="overlay"></div>
                    <div class="dropdown float-right ml-2">
                        <div><i class="fas fa-ellipsis-v text-light" (click)="toggleDropdown(exp.id)"></i></div>
                        <div class="dropdown-menu dropdown-menu-right text-right" [id]="'dropdown' + exp.id">
                            <span class="dropdown-item" [routerLink]="['./' + exp.id]">Modifica</span>
                            <span class="dropdown-item" (click)="deleteModal.show()">Elimina</span>
                        </div>
                    </div> -->
                    <!-- <i class="position-relative fas fa-pencil-ruler float-right text-warning ml-2" *ngIf="exp.edited"></i> -->
                    <div class="float-right" [placement]="'top'" [ngbTooltip]="exp.status === 'online' ? 'Experience online' : 'Experience offline'" tooltipClass="tooltip">
                        <i class="position-relative fas fa-circle" [class]="exp.status === 'online' ? 'text-success' : 'text-danger'"></i>
                    </div>
                </div>
                <div class="card-body">
                    <h5 class="card-title" [routerLink]="['./' + exp.id]">{{exp.title}}</h5>
                    <p class="card-text">{{ exp.description.length > 100 ? (exp.description | slice:0:100) + '..' : exp.description}}</p>
                </div>
            </div>


           <!--  <app-ui-modal #deleteModal dialogClass="modal-dialog-centered">
                <div class="app-modal-header">
                <h5 class="modal-title">Sicuro di voler eliminare la tua Experience?</h5>
                <button type="button" class="close basic-close" data-dismiss="modal" aria-label="Close" (click)="deleteModal.hide()"><span aria-hidden="true">&times;</span></button>
                </div>
                <div class="app-modal-body">
                    <p>
                        Eliminando "{{exp.title}}" perderai tutti i dati relativi alla Experience.
                    </p>
                </div>
                <div class="app-modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="deleteModal.hide();">Annulla</button>
                <button type="button" class="btn btn-primary" (click)="deleteModal.hide(); deleteExperience(exp.id);">Elimina</button>
                </div>
            </app-ui-modal> -->
        </div>
        <div class="col-12 col-md-3">
            <div class="add-new-card" [routerLink]="['./new']">
                <span>AGGIUNGI NUOVA EXPERIENCE</span>
            </div>
        </div>
    </div>
</app-card>

<!-- <div class="btn-group dropdown" ngbDropdown>
    <div ngbDropdownToggle data-toggle="dropdown-menu" id="addMenu">
        <i class="fal fa-plus-circle fa-lg"></i>
    </div>
    <ul class="list-unstyled dropdown-menu dropdown-menu-right" ngbDropdownMenu aria-labelledby="addMenu">
      <li class="dropdown-item full-card"><a href="javascript:"><span><i class="feather" ></i> aa</span></a></li>
      <li class="dropdown-item minimize-card"><a href="javascript:"><span><i class="feather"></i> bb </span>
        <span style="display:none"><i class="feather icon-plus"></i></span></a></li>
      <li class="dropdown-item reload-card"><a href="javascript:"><i class="feather icon-refresh-cw"></i> Reload</a></li>
      <li class="dropdown-item close-card"><a href="javascript:"><i class="feather icon-trash"></i> Remove</a></li>
    </ul>
</div> -->


<!-- <pre>
    {{(experiences$ | async)?.data | json}}
</pre> -->